module.exports = __webpack_public_path__ + "media/images/lb/175-66738d9b815cf96ffb97a2cdbd0b84bd.svg";